'use client';

import classNames from 'classnames';
import CheckSm from '@alltrails/denali/icons/CheckSm';
import type Tag from '@alltrails/types/Tag';
import styles from './PlanYourVisit.module.scss';
import icons from './tagIconMapping';

type GroupTagProps = {
  tag: Tag;
  isLightBackground: boolean;
  className?: string;
};

const GroupTag = ({ tag, isLightBackground, className }: GroupTagProps) => {
  const Icon = icons[tag.uid] || CheckSm;
  return (
    <div className={classNames(styles.tag, className)}>
      <div className={classNames(styles.iconBackground, { [styles.light]: isLightBackground })}>
        <Icon size="sm" />
      </div>
      <div className={styles.tagName}>{tag.name}</div>
    </div>
  );
};

export default GroupTag;
